import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const SuperAdminVenueAreaViewSchema: Types.ViewSchemaType<GQL.AreaFragment> = {
    enums: [
        {
            label: "Status",
            field: "area_status",
            type: "badge",
            relation_field: "display"
        },
        {
            label: "Type",
            field: "area_type",
            type: "badge",
            relation_field: "display"
        }
    ],
    fields: [
        {
            label: "Area Number",
            field: "area_number",
            type: "number"
        },
        {
            label: "Name",
            field: "name",
            type: "text"
        },
        {
            label: "Description",
            field: "description",
            type: "text"
        },
        {
            label: "Poc",
            field: "poc",
            type: "text"
        },
        {
            label: "Website",
            field: "website",
            type: "text"
        },
        {
            label: "Instagram",
            field: "instagram",
            type: "text"
        },
        {
            label: "Deleted",
            field: "deleted",
            type: "boolean"
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        }
    ],
    relations: {
        tenant: {
            relation: "tenant",
            label: "Tenant",
            fields: [
                {
                    label: "Id",
                    field: "id",
                    type: "text"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                }
            ]
        },
        venue: {
            relation: "venue",
            label: "Venue",
            fields: [
                {
                    label: "Id",
                    field: "id",
                    type: "text"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                }
            ]
        },
        created_by_user: {
            relation: "created_by_user",
            label: "Created By User",
            fields: [
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "First Name",
                    field: "first_name",
                    type: "text"
                },
                {
                    label: "Last Name",
                    field: "last_name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Role",
                    field: "role",
                    type: "text"
                }
            ]
        },
        updated_by_user: {
            relation: "updated_by_user",
            label: "Updated By User",
            fields: [
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "First Name",
                    field: "first_name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Role",
                    field: "role",
                    type: "text"
                }
            ]
        }
    }
}